import React, { useContext, useState } from "react";
import Context from "../utils/Context";
import API from "../api/api";
import ShowMessage from "./ShowMessage";

export default function Settings() {
  const context = useContext(Context);
  const [levelValues, setLevelValues] = useState([])
  const [areaSelected, setAreaSelected] = useState()


  const fetchAreas = async () => {
    const res = await API.fetchAreas({ "_id": areaSelected })
    if (res) {
      const importedValues = res.data[0].levelValues
      setLevelValues(importedValues)
      context.actions.setLevelValue(importedValues)
      context.actions.setMessage({ message: "Imported level values", type: "success" })
    }
  }

  const selectAreaType = (event) => {

    const areaType = context.areas.find(
      (areaType) => areaType.name === event.target.value
    )
    areaType ? setAreaSelected(areaType._id) : context.actions.setMessage({ message: "Please select area ", type: "error" })

  }


  return (
    <div>
      <div>
        <div className="control mb-5">
          <label className="label">Import Area Level</label>


          <select
            className="select"
            name="area"
            defaultValue={"Area..."}
            onChange={selectAreaType}
          >
            <option disabled>Areas...</option>
            {context.areas &&
              context.areas.map((item, i) => (
                <option key={i} value={item.name}>
                  {item.name}
                </option>
              ))}
          </select>


          <button className="button is-primary" onClick={fetchAreas}>
            Import Areas
          </button>
        </div>


        {context.levelValue.length > 0 && (
          <table className="table is-striped is-fullwidth">
            <thead>
              <tr>
                <th>Level</th>
                <th>Meters</th>
              </tr>
            </thead>
            <tbody>
              {context.levelValue.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <ShowMessage />
    </div>
  );
}